import React from "react";

import { Link, Text } from "@busbud/horizon";

import { useClientAppContext } from "@app/helpers/hooks";

export const PoweredByBusbud: React.FC<{ whitelabel_name?: string }> = ({
  whitelabel_name
}) => {
  const { translator, urlBuilder } = useClientAppContext();

  const url = urlBuilder.busbudHome({
    ...(whitelabel_name && { utm_source: whitelabel_name }),
    utm_medium: "e-commerce",
    utm_campaign: "powered-by"
  });

  return (
    <div className="flex items-center justify-center">
      <Text
        as="span"
        className="mr-150 font-weight-bold text-color-tertiary"
        size="sm"
      >
        {translator.t("!layout.powered-by")}&nbsp;
        <Link disableUnderline isMonochrome url={url}>
          Busbud.com
        </Link>
      </Text>
    </div>
  );
};
